// src/components/Footer.js
import React from 'react';
import { Box, Container, Grid, Typography, Divider, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#1e2128', color: 'white', pt: 6, pb: 0, mt: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>

          {/* Sol: Logo + açıklama */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 2 }}>
              <Box sx={{ backgroundColor: 'white', borderRadius: '10px', px: 1.5, py: 0.75, display: 'inline-flex', alignItems: 'center' }}>
                <img src="/logo.png" alt="İremOto" style={{ height: '44px', display: 'block' }} />
              </Box>
            </Box>
            <Typography variant="body2" sx={{ color: '#aaa', lineHeight: 1.8 }}>
              Renault ve Dacia araçlarına özel orijinal yedek parça kataloğu.
              Kalite ve güveni bir arada sunuyoruz.
            </Typography>
          </Grid>

          {/* Orta: Hızlı linkler */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2, color: '#f08a0c' }}>
              Hızlı Bağlantılar
            </Typography>
            {[
              { label: 'Ana Sayfa', to: '/' },
              { label: 'Ürün Kataloğu', to: '/urunler' },
              { label: 'Hakkımızda', to: '/hakkimizda' },
              { label: 'İletişim', to: '/contact' },
            ].map((item) => (
              <Box key={item.to} sx={{ mb: 1 }}>
                <MuiLink
                  component={Link}
                  to={item.to}
                  underline="none"
                  sx={{
                    color: '#ccc',
                    fontSize: '0.9rem',
                    '&:hover': { color: '#f08a0c' },
                    transition: 'color 0.2s',
                  }}
                >
                  {item.label}
                </MuiLink>
              </Box>
            ))}
          </Grid>

          {/* Sağ: İletişim */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2, color: '#f08a0c' }}>
              İletişim
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 1.5 }}>
              <LocationOnIcon sx={{ fontSize: 18, color: '#f08a0c', mt: '2px', flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#ccc', lineHeight: 1.7 }}>
                Merkez Sanayi Sitesi 1344. Cadde 19/A<br />Yenimahalle / ANKARA
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              <PhoneIcon sx={{ fontSize: 18, color: '#f08a0c', flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#ccc' }}>
                0312 395 22 25
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
              <AccessTimeIcon sx={{ fontSize: 18, color: '#f08a0c', mt: '2px', flexShrink: 0 }} />
              <Typography variant="body2" sx={{ color: '#ccc', lineHeight: 1.7 }}>
                Pzt–Cmt: 08:30–18:00<br />Pazar: Kapalı
              </Typography>
            </Box>
          </Grid>

        </Grid>
      </Container>

      {/* Alt: Telif hakkı */}
      <Box sx={{ mt: 5 }}>
        <Divider sx={{ borderColor: '#333' }} />
        <Box sx={{ py: 2, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#666' }}>
            © {new Date().getFullYear()} İremOto. Tüm hakları saklıdır.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
